import {useEffect, useRef, useState} from 'react';
import {LIC_KEY} from '../../App';
import {Button} from "react-bootstrap";

const arrayBufferToBase64 = (buffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

const generateShareLink = (arrayBuffer, fileName) => {
  // First delete the database
  const deleteRequest = indexedDB.deleteDatabase('PDFViewerDB');

  deleteRequest.onerror = (event) => {
    console.error('Error deleting IndexedDB:', event.target.error);
  };

  deleteRequest.onsuccess = () => {

    const dbRequest = indexedDB.open('PDFViewerDB', 1);

    dbRequest.onupgradeneeded = (event) => {
      const db = event.target.result;
      db.createObjectStore('pdfs', {keyPath: 'id'});
    };

    dbRequest.onerror = (event) => {
      console.error('IndexedDB error:', event.target.error);
    };

    dbRequest.onsuccess = (event) => {
      const db = event.target.result;
      const transaction = db.transaction(['pdfs'], 'readwrite');
      const store = transaction.objectStore('pdfs');

      const base64String = arrayBufferToBase64(arrayBuffer);

      const putRequest = store.put({
        id: fileName,
        data: base64String,
        timestamp: new Date().getTime()
      });

      putRequest.onerror = (event) => {
        console.error('Error saving PDF to IndexedDB:', event.target.error);
      };

      putRequest.onsuccess = () => {

      };
    };
  };
};

const handleShareClick = () => {
  // First check IndexedDB for token
  if (localStorage.getItem("token")) {
    window.open("/manage?ref=online-pdf-viewer");
  } else {
    window.open("/?ref=online-pdf-viewer");
  }
};

export default function PdfViewerTool() {
  const [documentFile, setDocumentFile] = useState(null);
  const viewerRef = useRef(null);
  const containerRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadend = () => {
        setDocumentFile({
          blob: new Blob([reader.result], {type: 'application/pdf'}),
          filename: file.name,
          arrayBuffer: reader.result
        });
        generateShareLink(reader.result, file.name);
      };
    } else {
      alert('Please upload a valid PDF file.');
    }
  };


  useEffect(() => {

    if (viewerRef.current) {
      try {
        viewerRef.current.UI.dispose();
        viewerRef.current = null;
      } catch (e) {
        console.error('Error disposing WebViewer:', e);
      }
    }

    if (documentFile && containerRef.current) {

      while (containerRef.current.firstChild) {
        containerRef.current.removeChild(containerRef.current.firstChild);
      }

      const isBlob = documentFile.blob instanceof Blob || documentFile instanceof File;

      import('@pdftron/webviewer').then(({default: WebViewer}) => {

        WebViewer({
          path: 'https://assets.tiiny.xyz/pdf-ui/webviewer',
          initialDoc: isBlob ? '' : documentFile,
          fullAPI: true,
          enableFilePicker: false,
          enableAnnotations: false,
          licenseKey: LIC_KEY,
          disabledElements: [
            'printButton',
            'downloadButton',
            'viewControlsButton',
            'menuButton',
            'annotationEditToolButton'
          ],
        }, containerRef.current).then((instance) => {
          viewerRef.current = instance;


          if (isBlob && documentFile.blob) {

            setTimeout(() => {
              try {
                instance.UI.loadDocument(documentFile.blob, {
                  filename: documentFile.filename || 'document.pdf',
                  extension: 'pdf',
                  freshStartMode: true
                });
              } catch (e) {
                console.error('Error loading blob document:', e);
              }
            }, 100);
          }
        }).catch(error => {
          console.error('Error initializing WebViewer:', error);
        });
      }).catch(error => {
        console.error('Error importing WebViewer:', error);
      });
    }

    return () => {
      if (viewerRef.current) {
        try {
          viewerRef.current.UI.dispose();
          viewerRef.current = null;
        } catch (e) {
          console.error('Error disposing WebViewer:', e);
        }
      }
    };
  }, [documentFile]);

  const triggerFileInput = () => {
    document.getElementById('fileInput').click();
  };

  return (
    <>
      <div className="top-bar">
        {documentFile && (<>
          <a href="https://tiiny.host" className="flex-grow-1 text-left">
            <img src="https://tiiny.host/assets/logo.png" height="45px" alt="Tiiny Host"/>
          </a>
          <div>
            <Button
              variant="outline-primary"
              onClick={triggerFileInput}
            >
              Choose PDF File
            </Button>
            <input
              id="fileInput"
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
              style={{display: 'none'}}
            />
            <Button onClick={handleShareClick} className="ml-2">
              Share as a Link
            </Button>
          </div>
        </>)}
      </div>
      <div className="sandbox">
        {!documentFile ? (
          <>
            <Button
              className="chooseFileBtn"
              size="lg"
              onClick={triggerFileInput}
            >
              Choose PDF File
            </Button>
            <input
              id="fileInput"
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
              style={{display: 'none'}}
            />
          </>
        ) : (
          <>
            <div ref={containerRef} style={{width: '100%', height: 'calc(100vh - 70px)'}}></div>
          </>
        )}
      </div>
    </>
  );
}